import { ComponentPropsWithRef } from "react";

export const UploadIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.7568 28.2469L23.7568 23.2469L18.7568 28.2469"
      fill="currentColor"
    />
    <path
      d="M28.7568 28.2469L23.7568 23.2469L18.7568 28.2469"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7568 23.2469V34.4969"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.2442 31.2344C35.4633 30.5698 36.4265 29.518 36.9815 28.2452C37.5366 26.9724 37.6519 25.551 37.3094 24.2053C36.9669 22.8596 36.186 21.6663 35.09 20.8137C33.994 19.9612 32.6452 19.4978 31.2567 19.4969H29.6817C29.3033 18.0335 28.5981 16.6748 27.6191 15.5232C26.6401 14.3715 25.4127 13.4567 24.0293 12.8477C22.6459 12.2386 21.1424 11.9511 19.6318 12.0068C18.1213 12.0624 16.643 12.4598 15.3081 13.169C13.9733 13.8782 12.8166 14.8808 11.9249 16.1014C11.0333 17.322 10.43 18.7288 10.1604 20.2162C9.89075 21.7035 9.9618 23.2326 10.3682 24.6885C10.7746 26.1444 11.5057 27.4893 12.5067 28.6219"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
